
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OnboardingStep from './OnboardingStep';
import { steps } from './tourSteps';
import { useTour } from './TourContext';
import { Capacitor } from '@capacitor/core';

const OnboardingTour: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { showTour, endTour } = useTour();
  const isNative = Capacitor.isNativePlatform();
  
  // Reset current step when tour is started
  useEffect(() => {
    if (showTour) {
      setCurrentStep(0);
      console.log('Tour started, platform:', Capacitor.getPlatform());
    }
  }, [showTour]);

  const handleNextStep = () => {
    if (currentStep === 1) {
      // Navigate to editor page for step 2
      navigate('/editor');
    } else if (currentStep === 7) {
      // Navigate back to home page for the final step
      navigate('/');
    }
    
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    if (currentStep === 2) {
      // Navigate back to home for step 1
      navigate('/');
    } else if (currentStep === 8) {
      // Navigate back to editor page
      navigate('/editor');
    }
    
    setCurrentStep((prev) => prev - 1);
  };

  const handleSkipTour = () => {
    endTour();
  };

  const handleFinishTour = () => {
    endTour();
  };

  // Don't show tour if it's not active
  if (!showTour) return null;
  
  // Only show steps that are relevant to the current page
  const currentPath = location.pathname;
  const isHome = currentPath === '/';
  const isEditor = currentPath === '/editor';
  
  // Filter steps based on current page
  const visibleStep = steps[currentStep];
  const isStepVisible = 
    (isHome && visibleStep.page === 'home') || 
    (isEditor && visibleStep.page === 'editor') ||
    visibleStep.page === 'any';
  
  if (!isStepVisible) return null;

  return (
    <OnboardingStep
      step={visibleStep}
      currentStep={currentStep}
      totalSteps={steps.length}
      onNext={handleNextStep}
      onPrev={handlePrevStep}
      onSkip={handleSkipTour}
      onFinish={handleFinishTour}
    />
  );
};

export default OnboardingTour;
